import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

export enum ModuleHeaderSize {
  Large = 'large',
  Small = 'small',
}

type Props = {
  title?: string | React.ReactNode;
  subtitle?: string;
  children?: React.ReactNode;
  size?: ModuleHeaderSize;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>;

export function ModuleHeader({
  title,
  subtitle,
  children,
  size = ModuleHeaderSize.Large,
  className = '',
  ...rest
}: Props) {
  const isLarge = size === ModuleHeaderSize.Large;
  const isSmall = size === ModuleHeaderSize.Small;

  return (
    <div
      {...rest}
      className={clsx({
        [className]: Boolean(className),
        [styles.header]: true,
        [styles['header--large']]: isLarge,
        [styles['header--small']]: isSmall,
      })}
    >
      <div>
        {Boolean(title) && (
          <Heading as="h2" variant={isSmall ? 'md' : 'lg'}>
            {title}
          </Heading>
        )}
        {subtitle && <Body variant="sm-regular">{subtitle}</Body>}
      </div>
      {children}
    </div>
  );
}
